import styled from "vue-styled-components";

export const Content = styled.div`
    display: flex;
    margin-bottom: 2rem;

    > figure {
        display: flex;
        justify-content: center;
        align-self: center;
        width: 100%;
        flex: 0 0 180px;
        max-width: 90px;
        border: 1px solid #ddd;
        margin-right: 1.5rem;
        margin-bottom: 0;
        img {
            object-fit: contain;
        }
    }

    .product-principal-purchase {
        align-self: center;

        h3 {
            font-size: 1.6rem;
            margin: 0;
            font-weight: 500;
        }

        h3 + p {
            margin-top: 1.2rem;
        }

        p {
            position: unset;
            margin: 0.5rem 0 0;
            font-size: 1.3rem;
            font-weight: 400;
        }

        .purchase__flavor + .purchase__flavor::before {
            content: " / ";
        }

        .additional-files {
            margin-top: 1.3rem;
            a {
                text-decoration: none;
                display: flex;
                align-items: center;
            }
            i {
                font-size: 2.2rem;
                cursor: pointer;
                margin-right: 0.5rem;
            }
            &:hover a strong {
                text-decoration: underline;
            }
        }
    }

    .product-children-purchase {
        padding-bottom: 2rem;

        .product-child-purchase {
            display: flex;

            + .product-child-purchase {
                margin-top: 1rem;
            }

            figure {
                display: flex;
                align-items: center;
                width: 8.5rem;
                min-width: 8.5rem;
                margin: 0 1rem 0 0;
            }

            > div {
                align-self: center;
                p {
                    margin-bottom: 0;
                }
                p + p {
                    margin-top: 0.3rem;
                }
            }
        }
    }

    @media (max-width: 465px) {
        margin-bottom: 2rem;
        border-bottom: 1px solid ${props => props.theme?.my_account?.cards?.border_color ?? '#ddd'};

        figure {
            margin: 0;
        }
    }

    /* .product-wishlist p {
        bottom: 10px;
        font-weight: bold;
        font-size: 12px;
        position: absolute;
        color: #000;
    } */
`;
